import { fetchDrugSkus, fetchQuestionnaire } from 'features/questionnaire/api/questionnaireApi';

import { loadLaunchPromotion } from 'features/promotions/launchPromoData';

// Reuse public definitions/catalogue for this page visit; a full reload starts fresh.
// Public definitions/catalogue only. Never cache questionnaire answers, accounts or sessions.
const publicCache = <T>(fetchValue: (key: string) => Promise<T>) => {
  const values = new Map<string, T>();
  const pending = new Map<string, Promise<T>>();
  const read = (key: string): T | null => values.get(key) ?? null;
  const load = (key: string): Promise<T> => {
    const cached = read(key);
    if (cached) return Promise.resolve(cached);
    const existing = pending.get(key);
    if (existing) return existing;
    const request = fetchValue(key)
      .then((value) => {
        values.set(key, value);
        return value;
      })
      .finally(() => pending.delete(key));
    pending.set(key, request);
    return request;
  };
  return {
    read,
    load,
    clear: () => {
      values.clear();
      pending.clear();
    },
  };
};
const questionnaires = publicCache(fetchQuestionnaire);
const catalogue = publicCache(fetchDrugSkus);
export const loadEdQuestionnaire = () => questionnaires.load('ed-v2');
export const loadEdSkus = catalogue.load;
export const readEdSkus = catalogue.read;
export const warmEdJourney = () =>
  Promise.allSettled([loadEdQuestionnaire(), loadEdSkus('sildenafil'), loadEdSkus('tadalafil'), loadLaunchPromotion()]);
export const clearEdPublicDataCache = () => {
  questionnaires.clear();
  catalogue.clear();
};
